// extracted by mini-css-extract-plugin
export default {"BioTitle":"bio_BioTitle__RnkxC","project":"bio_project__rJbVZ","showIN":"bio_showIN__r++aM","sidebar":"bio_sidebar__qDtjx","slideIn":"bio_slideIn__m2cLi"};